
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { formatAddress , dateFormat, dashedVid} from '@/utils/index'
@Component({
  components: {},
  filters:{}
})
export default class Test extends Vue {
  
  /// props
//   @Prop({ default: '' }) private record!: any
  @Prop() private record!: any

  @Prop() private type!: string
  
  /// data
  private data: Object = {}

  private get name(): string {
    let {base} = this.record
    return base && base.name
  }
  private get department(): string {
    return this.record && this.record.custom && this.record.custom.department
  }
  private get address(): string {
    let gps = this.record && this.record.custom && this.record.custom.gps
    return gps && formatAddress(gps) || ""
  }

  private get dateTime(): string {
    let timestamp = this.record && this.record.base && this.record.base.timestamp
    return timestamp && dateFormat(timestamp, 'yyyy-MM-dd') || ""
    // dateFormat(item.Parametervalue4, 'yyyy-MM-dd') || ''
  }

  private get dashedTxid(): string {
    let txId = this.record && this.record.blockinfo && this.record.blockinfo.txId || ""
    return dashedVid(txId)
  }

  private get typeIcon(): any {
    if(this.type == 'track') {
      return require('@/assets/imgs/icon-track-record-01@2x.png')
    } else {
      return require('@/assets/imgs/icon-meterial-record-01@2x.png')
    }
  }

  public openTxRecord() {
      let {blockinfo} = this.record
      let explorerUrl = this.$store.state.explorerUrl
      let txId = blockinfo && blockinfo.txId || ""
      // txId && window.open(explorerUrl + "/transactions/" + txId)
      // this.$router.push({name: "BlockDetail",  query: {txId: txId}})
      if(document.domain.endsWith(".cn")){
        this.$router.push({name: "BlockDetail",  query: {txId: txId}})
      }else{
        txId && window.open(explorerUrl + "/transactions/" + txId)
      }
  }

  public sectionDetail() {
    this.$emit('detail', this.record)
  }
  
  /// provide data
  @Provide() provideData: Object = {}
  
  // computed
  private get infos(): Array<any> {
      return Array<any>()
  }
  
  /// lifecycle
  created() {
    
  }
  
  mounted() {
    
  }
  
  /// methods
  public methodOne(params: any): void {
    
  }
  /// watch methods
  @Watch('newList', { immediate: true, deep: true })
  onArrayChanged(newVal: any, oldVal: any) {
    
  }
}
